/**
 * Доступ к плееру камер (сторонний скрипт vplatform.edgevideo.ru).
 *
 * Раньше код обращался к глобальной переменной EdgePlayer напрямую. Когда
 * скрипт провайдера перестал отдаваться (бакет vp-player отвечает AccessDenied),
 * это превращалось в ReferenceError внутри useEffect: React срывал рендер и
 * страница /web-cams показывала «Application error» целиком, вместо того чтобы
 * просто остаться без видео.
 *
 * Ждём появления глобала ограниченное время: скрипт подключён как внешний и
 * может приехать позже гидратации, но если он не приедет вовсе — отдаём null,
 * и вызывающий код просто не инициализирует плеер.
 */

type EdgePlayerMethod = { name: string };

export type EdgePlayerInstance = {
  method: (method: EdgePlayerMethod) => void;
  on: (event: string, handler: () => void) => void;
  destroy: () => void;
};

export type EdgePlayerApi = new (
  iframe: HTMLIFrameElement,
) => EdgePlayerInstance;

const getApi = (): EdgePlayerApi | null => {
  const global = window as typeof window & {
    EdgePlayer?: { eplayerAPI?: EdgePlayerApi };
  };

  return global.EdgePlayer?.eplayerAPI ?? null;
};

const DEFAULT_TIMEOUT_MS = 10_000;
const POLL_INTERVAL_MS = 200;

export const waitForEdgePlayerApi = (
  timeoutMs: number = DEFAULT_TIMEOUT_MS,
): Promise<EdgePlayerApi | null> => {
  const immediate = getApi();

  if (immediate) return Promise.resolve(immediate);

  return new Promise((resolve) => {
    const startedAt = Date.now();

    const timer = setInterval(() => {
      const api = getApi();

      if (api) {
        clearInterval(timer);
        resolve(api);
        return;
      }

      if (Date.now() - startedAt >= timeoutMs) {
        clearInterval(timer);
        console.warn(
          "[edge-player] Скрипт плеера камер не загрузился, видео недоступно",
        );
        resolve(null);
      }
    }, POLL_INTERVAL_MS);
  });
};
